import {
	get,
	post,
	put,
	Delete
} from './request.js'
import axios from 'axios'
import qs from 'qs'

//登录
export const Login = () => {
	return new Promise((resolve, reject) => {
		post('https://cj.cpzspt.cn/pananapi/test/ruoyi-vue-pro/admin-api/system/auth/login', {
			username: "cjjhjc01",
			password: "Cjjhjc0304"
		}, {
			'Content-Type': 'application/json; charset=utf-8',
			'Tenant-Id': '1'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}
//获取实时数据
export const GetWeatherNow = () => {
	// 获取Token
	const storedToken = window.localStorage.getItem('token');
	return new Promise((resolve, reject) => {
		post('https://cj.cpzspt.cn/pananapi/test/ruoyi-vue-pro/admin-api/report/panan/get-last-node', {
			deviceAddr: '40245907'
		}, {
			'Content-Type': 'application/json; charset=utf-8',
			'Authorization': 'Bearer 8ae2b06385424a67b0b413874d091836',
			'Tenant-Id': '1'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}

//以天为单位获取数据
export const GetWeatherData = (option) => {
	return new Promise((resolve, reject) => {
		post('https://cj.cpzspt.cn/pananapi/test/ruoyi-vue-pro/admin-api/report/panan/get-his-env', {
			deviceAddr: option.deviceAddr,
			environmentId: option.environmentId,
			beginTime: option.beginTime,
			endTime: option.endTime
		}, {
			'Content-Type': 'application/json; charset=utf-8',
			'Authorization': 'Bearer 8ae2b06385424a67b0b413874d091836',
			'Tenant-Id': '1'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}
//以天为单位获取数据
export const GetWeatherTime = (option) => {
	return new Promise((resolve, reject) => {
		post('https://cj.cpzspt.cn/pananapi/test/ruoyi-vue-pro/admin-api/report/panan/get-node-his', {
			deviceAddr: option.deviceAddr,
			environmentId: option.environmentId,
			beginTime: option.beginTime,
			endTime: option.endTime
		}, {
			'Content-Type': 'application/json; charset=utf-8',
			'Authorization': 'Bearer 8ae2b06385424a67b0b413874d091836',
			'Tenant-Id': '1'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}

//根据时间获取环境的所有历史记录节点图
export const GetEnvPage = (pageNo, option) => {
	return new Promise((resolve, reject) => {
		post(`https://cj.cpzspt.cn/pananapi/test/ruoyi-vue-pro/admin-api/report/panan/get-env-page?pageNo=${pageNo}&pageSize=10`, {
			deviceAddr: option.deviceAddr,
			environmentIdList: option.environmentIdList,
			beginTime: option.beginTime,
			endTime: option.endTime
		}, {
			'Content-Type': 'application/json; charset=utf-8',
			'Authorization': 'Bearer 8ae2b06385424a67b0b413874d091836',
			'Tenant-Id': '1'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}

//获取水肥数据记录表
export const GetWateringFertilizationTables = (options) => {
	return new Promise((resolve, reject) => {
		get('https://cj.cpzspt.cn/cjzyandgrape/api/Grape/GetWateringFertilizationTables/' + options, {
			'Content-Type': 'application/json; charset=utf-8'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}

//获取用户表
export const GetUserTables = (options) => {
	return new Promise((resolve, reject) => {
		get('https://cj.cpzspt.cn/cjzyandgrape/api/Grape/GetUserTables/' + options, {
			'Content-Type': 'application/json; charset=utf-8'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}


//查询水肥数据记录表详情
export const GetWateringFertilizationTablesDetail = (options) => {
	return new Promise((resolve, reject) => {
		get('https://cj.cpzspt.cn/cjzyandgrape/api/Grape/GetWateringFertilizationTablesDetail/' + options, {
			'Content-Type': 'application/json; charset=utf-8'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}
//添加水肥数据记录表详情
export const InsertWateringFertilizationTablesDetail = (options) => {
	return new Promise((resolve, reject) => {
		get('https://cj.cpzspt.cn/cjzyandgrape/api/Grape/InsertWateringFertilizationTablesDetail',
		options, {
			'Content-Type': 'application/json; charset=utf-8'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}

//删除水肥数据记录表详情
export const DeleteWateringFertilizationTablesDetail = (options) => {
	return new Promise((resolve, reject) => {
		Delete('https://cj.cpzspt.cn/cjzyandgrape/api/Grape/DeleteWateringFertilizationTablesDetail/' +
			options, {
				'Content-Type': 'application/json; charset=utf-8'
			}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}
//获取环境数据记录表
export const GetEnvironmentalmonitoringtables = () => {
	return new Promise((resolve, reject) => {
		get('https://cj.cpzspt.cn/cjzyandgrape/api/Grape/GetEnvironmentalmonitoringtables/40266183', {
			'Content-Type': 'application/json; charset=utf-8'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}

//修改环境是否启用
export const IsEnableEnvironment = (options) => {
	return new Promise((resolve, reject) => {
		put('https://cj.cpzspt.cn/cjzyandgrape/api/Grape/IsEnableEnvironment/' + options, {
			'Content-Type': 'application/json; charset=utf-8'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}


//修改电话号码
export const Updatephone = (options) => {
	return new Promise((resolve, reject) => {
		put('https://cj.cpzspt.cn/cjzyandgrape/api/Grape/UpdatePhone/1', {
			phone: options
		}, {
			'Content-Type': 'application/json; charset=utf-8'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}



//修改环境阈值
export const UpdateEnvironment = (id, options) => {
	return new Promise((resolve, reject) => {
		put('https://cj.cpzspt.cn/cjzyandgrape/api/Grape/UpdateEnvironment/' + id, options, {
			'Content-Type': 'application/json; charset=utf-8'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}



//获取预警信息表
export const GetWarningtables = (option) => {
	return new Promise((resolve, reject) => {
		get('https://cj.cpzspt.cn/cjzyandgrape/api/Grape/GetWarningtables/' + option, {
			'Content-Type': 'application/json; charset=utf-8'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}



//修改预警信息表处理人
export const UpdateResolvedPeople = (id, resolvedPeople) => {
	return new Promise((resolve, reject) => {
		put(`https://cj.cpzspt.cn/cjzyandgrape/api/Grape/UpdateResolvedPeople/${id}`, {
			resolvedPeople
		}, {
			'Content-Type': 'application/json; charset=utf-8'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}

//根据时间获取环境的所有历史记录节点图
export const GetEnvAdd = (pageNo, option) => {
	return new Promise((resolve, reject) => {
		post(`https://cj.cpzspt.cn/pananapi/test/ruoyi-vue-pro/admin-api/report/panan/get-env-add`, {
			"deviceAddr": 40245907,
			"productId": 3000,
			"beginTime": "2024-08-01",
			"endTime": "2024-08-20"
		}, {
			'Content-Type': 'application/json; charset=utf-8',
			'Authorization': 'Bearer 8ae2b06385424a67b0b413874d091836',
			'Tenant-Id': '1'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}

//获取视屏tokken
export const Gettoken = () => {
	return new Promise((resolve, reject) => {
		post("https://open.ys7.com/api/lapp/token/get", qs.stringify({
			appSecret: '11314eb5c4c379f1894b9ffe4fcb05ad',
			appKey: '9d1cc2a5d6eb4d409f55a38f98a46169',
		}), {
			'Content-Type': 'application/x-www-form-urlencoded'
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err)
		})
	})
}